// FILE: src/components/DashCard.js
//
// Reusable card primitive used across the redesigned dashboard. One shell,
// many uses — readiness hero, roadmap, mini cards, milestones, rail cards.
//
//   <DashCard eyebrow="Your Journey" action={<a href="#">View milestones ›</a>}>
//     ...body...
//   </DashCard>

import React from 'react';
import styles from './DashCard.module.css';

export default function DashCard({
  eyebrow,
  eyebrowIcon,
  action,
  className = '',
  bodyClassName = '',
  tight = false,
  children,
  testId,
}) {
  const rootClass = [styles.card, tight ? styles.tight : '', className].filter(Boolean).join(' ');
  return (
    <section className={rootClass} data-testid={testId}>
      {(eyebrow || action) && (
        <header className={styles.head}>
          {eyebrow && (
            <span className={styles.eyebrow}>
              {eyebrowIcon ? <span className={styles.eyebrowIcon}>{eyebrowIcon}</span> : null}
              {eyebrow}
            </span>
          )}
          {action && <span className={styles.action}>{action}</span>}
        </header>
      )}
      <div className={[styles.body, bodyClassName].filter(Boolean).join(' ')}>{children}</div>
    </section>
  );
}
